import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { createForecastTrackingMatrix } from "../../utils/forecast_tracking_matrix";

export const ForecastTrackingContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "forecast_tracking",
        transformId: "forecast_tracking",
        folder: "outputs",
        title: "Forecast Tracking",
        dateHierarchyColumnFilter: {
          order_delivery_month: "month",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          forecast: "forecast",
          "realized forecast": "realized forecast",
          orders: "orders",
          delivered: "delivered",
          open: "open",
          remainder: "remainder",
          "pct ordered": "pct ordered",
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.DatePeriodPicker,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createForecastTrackingMatrix,
        chunkedMatrixTransformId: "forecast_tracking_matrix",
        excludeDetailRows: true,
        breakdownMeasures: ["delivered"],
        additionalMeasuresWithTotals: ["delivered", "open"],
        // Greys out historical (past/current) month columns, matching the
        // demand/supply no-perspective views. Note: forecast_tracking uses a
        // custom matrix renderer (forecast_tracking_matrix.ts) that applies the
        // shading directly via isHistoricalDate; this flag declares intent
        // consistently with the other views.
        shadeHistory: true,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
